import http from 'hub-http/clients/apiClient';
import { mapProperties } from 'invoices-ui-lib/utils/property';
export function fetchAvailableManualPaymentMethods(currencyCode) {
  return http.get(`/commerce-payment-methods/v1/${currencyCode}/all?validateProcessorSupportedCurrency=false`);
}
const createCommercePaymentServiceRequest = paymentRecord => Object.assign({}, paymentRecord, {
  associatedObjects: {
    COMMERCE_PAYMENT_TO_INVOICE: [Object.assign({}, paymentRecord.associatedObjects.COMMERCE_PAYMENT_TO_INVOICE[0], {
      properties: mapProperties(paymentRecord.associatedObjects.COMMERCE_PAYMENT_TO_INVOICE[0].properties)
    })],
    COMMERCE_PAYMENT_TO_CONTACT: [Object.assign({}, paymentRecord.associatedObjects.COMMERCE_PAYMENT_TO_CONTACT[0], {
      properties: mapProperties(paymentRecord.associatedObjects.COMMERCE_PAYMENT_TO_CONTACT[0].properties)
    })]
  },
  properties: mapProperties(paymentRecord.properties)
});
export function createCommercePaymentObject({
  commercePayment,
  lastEditDate,
  shouldSendReceipt
}) {
  const queryParams = new URLSearchParams();
  if (lastEditDate && shouldSendReceipt) {
    queryParams.set('lastEditDate', lastEditDate);
    queryParams.set('shouldSendReceipt', 'true');
  } else if (lastEditDate) {
    queryParams.set('lastEditDate', lastEditDate);
  } else if (shouldSendReceipt) {
    queryParams.set('shouldSendReceipt', 'true');
  }
  const queryParamsString = queryParams.toString().length ? `?${queryParams.toString()}` : '';
  return http.post(`invoices/v1/hubspot-payment/external-payment${queryParamsString}`, {
    data: createCommercePaymentServiceRequest(commercePayment)
  });
}
export function fetchCommercePaymentMethodTypeProperty() {
  return http.get('properties/v4/COMMERCE_PAYMENT/named/hs_payment_method_type');
}